import $ from 'jquery'
import './jquery-resize-debounce'
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import googleCalendarPlugin from '@fullcalendar/google-calendar'
$(document).ready(function() {
	const calendarEle = document.getElementById('fw-calendar')
	if (calendarEle) {
		const useGoogleCalendar = calendarEle.getAttribute('data-source-google') == 1
		const googleCalendarId = calendarEle.getAttribute('data-google-cid')
		const googleCalendarApiKey = calendarEle.getAttribute('data-google-api')
		const calendar = new Calendar(calendarEle, {
			...{
				plugins: [
					...(useGoogleCalendar ? [googleCalendarPlugin] : []),
					...[dayGridPlugin, listPlugin]
				],
				defaultView: $(window).width() < 768 ? 'listWeek' : 'dayGridMonth',
				header: {
					left: 'prev,next',
					center: 'title',
					right: 'dayGridMonth,listWeek'
				},
				events: useGoogleCalendar
					? {
							googleCalendarId: googleCalendarId
					  }
					: wp_data.home_url + '/wp-admin/admin-ajax.php?action=fw_get_events',
				loading: function(bool) {
					$('#fw-calendar-loading').toggle(bool)
					$('#fw-calendar').toggleClass('waiting', bool)
				},
				eventClick: function(info) {
					info.jsEvent.preventDefault()
					if (info.event.url) {
						window.open(
							useGoogleCalendar
								? info.event.url + '&ctz=' + calendarEle.getAttribute('data-timezone')
								: info.event.url
						)
					}
				}
			},
			...(useGoogleCalendar ? { googleCalendarApiKey: googleCalendarApiKey } : {})
		})

		const calendarViewerChanger = () => {
			let view = $(window).width() < 768 ? 'listWeek' : 'dayGridMonth'
			calendar.changeView(view)
		}
		//Render the calendar;
		calendar.render()

		$(window).smartresize(function() {
			calendarViewerChanger()
		})
	}
})
